<template>
  <div class="est-calc-container" :class="row ? 'row' : ''">
    <div>
      <input type="radio" :id="id" :name="name" v-model="radioButtonValue" />
      <label class="thumbnail" :style="{ backgroundImage: 'url(' + imageUrl + ')' }" :for="id" />
    </div>
    <div :class="row ? 'margin-left-big' : ''">
      <h4 class="label">{{label}}</h4>
      <span class="small-paragraph">
        <slot name="description"></slot>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "AnswerOptionImage",
  props: ["id", "name", "value", "label", "imageUrl", "row"],
  computed: {
    radioButtonValue: {
      get: function() {
        return this.value;
      },
      set: function() {
        this.$emit("change", this.value);
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.thumbnail {
  cursor: pointer;
  background-size: contain;
  background-repeat: no-repeat;
  font-family: var(--font-default);
  display: inline-block;
  width: 32vw;
  height: 32vw;
  border: 3px solid transparent;
}

.label {
  font-weight: 700;
  font-family: var(--font-default);
  font-size: 12px;
}

.row {
  display: flex;
  flex: 1 auto;
  justify-content: center;
}

input {
  margin: 0;
  padding: 0;
  display: none;
}

.est-calc-container {
  width: min-content;
  padding: 10px;
  text-align: left;
}

.est-calc-container.row {
  width: auto;
  justify-content: initial;
}

input[type="radio"]:checked + .thumbnail,
input[type="radio"]:hover + .thumbnail,
.text-answer-container > input[type="radio"]:checked + label {
  border: 3px solid transparent;
  outline: 3px solid var(--primary-green);
}

@media (min-width: $small) {
  .label {
    font-size: 14px;
  }
}

@media (min-width: $medium) {
  .thumbnail {
    width: 30vw;
    height: 30vw;
  }

  .label {
    font-size: 16px;
  }
}
@media (min-width: $large) {
  .thumbnail {
    width: 13vw;
    height: 13vw;
  }
}

@media (min-width: $x-large) {
  .thumbnail {
    width: 11vw;
    height: 11vw;
  }
}
</style>
